const ColorArray = [
    "424242",
    "000000",
    "2F394B",
    "1D3557",
    "687da1",
    "8DC8FF",
    "9D2730",];
export { ColorArray };
